import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import SearchForm from '@/components/SearchForm'
import ServiceSelection from '@/components/ServiceSelection'
import PaymentForm from '@/components/Payment/PaymentForm'
import CustomerForm from '@/components/Customer/CustomerForm'
import Customer from '@/components/Customer'
import ReviewDetails from '@/components/Review/ReviewDetails'
import EditSearch from '@/components/SearchEdit'
import EditRsvp from '@/components/RsvpEdit'
import SearchTrack from '@/components/SearchTrack'
import RsvpTrack from '@/components/RsvpTrack'
import ResetPassword from '@/components/ResetPassword'
import ThankYou from '@/components/ThankYou'
import img from '@/components/Global/ImageSlider'

import Search from '@/components/Search'

import D2DService from '@/components/D2DService'
// import D2DExtras from '@/components/D2DOthers/Extras'
// import D2DItinerary from '@/components/D2DOthers/Itinerary'
import D2DItinerary from '@/components/D2DItinerary'
import D2DReview from '@/components/D2DReview'
// import D2DPaxForm from '@/components/D2DOthers/PaxForm'
// import D2DReview2 from '@/components/D2DOthers/Review'
import D2DSuccess from '@/components/D2DOthers/Success'
import D2DFlightList from '@/components/D2DFlights'

import D2DThingsList from '@/components/D2DThingsList'
import D2DThingsDetails from '@/components/D2DThingsList/details'
import D2DThingsReview from '@/components/D2DThingsList/review'
import D2DThingsThankyou from '@/components/D2DThingsList/thankyou'

import D2DSightSeeingList from '@/components/D2DSightSeeing'
import D2DSightSeeingDetails from '@/components/D2DSightSeeing/details'
import D2DSightSeeingTrip from '@/components/D2DSightSeeing/trips'
import D2DSightSeeingReview from '@/components/D2DSightSeeing/review'
import D2DSightSeeingThankyou from '@/components/D2DSightSeeing/thankyou'

import D2DHotelList from '@/components/D2DHotel'
import D2DHotelDetails from '@/components/D2DHotel/details'
import D2DHotelRooms from '@/components/D2DHotel/rooms'
import D2DHotelReview from '@/components/D2DHotel/review'
import D2DHotelThankyou from '@/components/D2DHotel/thankyou'

import D2DEmailTest from '@/components/D2DOthers/EmailTest'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    // {
    //   path: '/search2',
    //   name: 'Search2',
    //   component: SearchForm
    // },
    // {
    //   path: '/booking1',
    //   name: 'Booking1',
    //   component: SearchForm
    // },
    // {
    //   path: '/booking2',
    //   name: 'Booking2',
    //   component: SearchForm
    // },
    {
      path: '/track',
      name: 'Track',
      component: SearchForm
    },
    {
      path: '/service',
      name: 'ServiceSelection',
      component: ServiceSelection,
      meta: {
        groundFull: true
      }
    },
    {
      path: '/payment',
      name: 'Payment',
      component: PaymentForm,
      props: true,
      meta: {
        isD2d: false,
        showPaymentSummary: true,
        groundFull: true
      }
    },
    // {
    //   path: '/customer',
    //   name: 'Customer',
    //   component: CustomerForm,
    //   props: true,
    //   meta: {
    //     isD2d: false,
    //     showPaymentSummary: true,
    //     groundFull: true
    //   }
    // },
    {
      path: '/customer',
      name: 'Customer',
      component: Customer,
      props: true,
      meta: {
        isD2d: false,
        showPaymentSummary: true,
        groundFull: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: CustomerForm,
      props: { showLoginBox: true }
    },
    {
      path: '/review',
      name: 'Review',
      component: ReviewDetails,
      props: true,
      meta: {
        isD2d: false,
        showPaymentSummary: true,
        groundFull: true
      }
    },
    {
      path: '/search-edit',
      name: 'SearchEdit',
      component: EditSearch,
      props: true
    },
    {
      path: '/rsvp-edit',
      name: 'RsvpEdit',
      component: EditRsvp,
      props: true,
      meta: {
        hideCurrency: true
      }
    },
    {
      path: '/search-track',
      name: 'SearchTrack',
      component: SearchTrack,
      props: true,
      meta: {
        hideCurrency: true
      }
    },
    {
      path: '/search-track-direct/',
      name: 'SearchTrackDirect',
      component: SearchTrack,
      props: true,
      meta: {
        hideCurrency: true
      }
    },
    {
      path: '/rsvp-track',
      name: 'RsvpTrack',
      component: RsvpTrack,
      props: true,
      meta: {
        hideCurrency: true
      }
    },
    {
      path: '/driver-review',
      name: 'DriverReview',
      component: SearchForm,
      meta: {
        hideCurrency: true
      }
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      props: true,
      meta: {
        hideCurrency: true
      }
    },
    {
      path: '/booking2/complete',
      name: 'ThankYou',
      component: ThankYou,
      props: true
    },
    {
      path: '/d2dservice',
      name: 'D2DService',
      component: D2DService,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        fullScreen: true
      },
      props: true
    },
    {
      path: '/d2ditinerary',
      name: 'D2DItinerary',
      component: D2DItinerary,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        fullScreen: true
      },
      props: true
    },
    {
      path: '/review-summary',
      name: 'D2DReview',
      component: D2DReview,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        fullScreen: true
      },
      props: true
    },
    {
      path: '/img',
      name: 'img',
      component: img,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        fullScreen: true
      },
      props: true
    },
    // {
    //   path: '/d2dextras',
    //   name: 'D2DExtras',
    //   component: D2DExtras,
    //   meta: {
    //     isD2d: true,
    //     showPaymentSummary: false
    //   },
    //   props: true
    // },
    // {
    //   path: '/pax-info',
    //   name: 'D2DPaxForm',
    //   component: D2DPaxForm,
    //   meta: {
    //     isD2d: true,
    //     showPaymentSummary: false
    //   },
    //   props: true
    // },
    // {
    //   path: '/review-summary2',
    //   name: 'D2DReview2',
    //   component: D2DReview2,
    //   meta: {
    //     isD2d: true,
    //     showPaymentSummary: true
    //   },
    //   props: true
    // },
    {
      path: '/booking1/complete',
      name: 'D2DSuccess',
      component: D2DSuccess,
      meta: {
        isD2d: true,
        showPaymentSummary: false
      },
      props: true
    },
    {
      path: '/my-flights',
      name: 'D2DFlightList',
      component: D2DFlightList,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/things',
      name: 'D2DThingsList',
      component: D2DThingsList,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/things/view',
      name: 'D2DThingsDetails',
      component: D2DThingsDetails,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/things/review',
      name: 'D2DThingsReview',
      component: D2DThingsReview,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/things/thankyou',
      name: 'D2DThingsThankyou',
      component: D2DThingsThankyou,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/sight-seeing',
      name: 'D2DSightSeeingList',
      component: D2DSightSeeingList,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/sight-seeing/view',
      name: 'D2DSightSeeingDetails',
      component: D2DSightSeeingDetails,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/sight-seeing/trips',
      name: 'D2DSightSeeingTrip',
      component: D2DSightSeeingTrip,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/sight-seeing/review',
      name: 'D2DSightSeeingReview',
      component: D2DSightSeeingReview,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/sight-seeing/thankyou',
      name: 'D2DSightSeeingThankyou',
      component: D2DSightSeeingThankyou,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/hotel',
      name: 'D2DHotelList',
      component: D2DHotelList,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/hotel/view',
      name: 'D2DHotelDetails',
      component: D2DHotelDetails,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/hotel/rooms',
      name: 'D2DHotelRooms',
      component: D2DHotelRooms,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/hotel/review',
      name: 'D2DHotelReview',
      component: D2DHotelReview,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: false
      },
      props: true
    },
    {
      path: '/hotel/thankyou',
      name: 'D2DHotelThankyou',
      component: D2DHotelThankyou,
      meta: {
        isD2d: true,
        showPaymentSummary: false,
        hideCurrency: true
      },
      props: true
    },
    {
      path: '/email-test',
      name: 'D2DEmailTest',
      component: D2DEmailTest,
      meta: {
        isD2d: true,
        showPaymentSummary: false
      },
      props: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  // console.log('ROUTER TO -- ', to)
  // console.log('ROUTER FROM -- ', from)
  if (to.name === 'D2DService' && from.name === 'D2DItinerary') {
    store.commit('reservation/setD2DData', {
      fetch: [
        'Economy',
        'PremiumEconomy',
        'Business',
        // 'PremiumBusiness',
        'First'
      ]
    })
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js